import { AIFormAction } from '../index';

// 理疗类型对应的步骤
export const THERAPY_TYPE_2_STEP: Record<AIDiagnose.TherapyType, AIFormAction[]> = {
  weightLoss: ['selectPart', 'currentDimension', 'targetDimension'],
  bodyAdjust: ['postureCondition', 'postureConditionLevel'],
  painRelief: ['markPainArea', 'painConditionLevel'],
  physicalImprove: ['physicalCondition', 'physicalConditionLevel', 'tongueDiagnosis'],
};

export const THERAPY_TYPE_2_TEXT: Record<AIDiagnose.TherapyType, string> = {
  weightLoss: '减肥瘦身',
  bodyAdjust: '体态调整',
  painRelief: '痛症舒缓',
  physicalImprove: '体质调理',
};

// 选择融合方案时，不同理疗类型表单填写排序规则
export const THERAPY_TYPE_SORT_ORDER = Object.keys(THERAPY_TYPE_2_TEXT) as AIDiagnose.TherapyType[];

// 根据选择的理疗类型生成步骤
export const genStepsBySelectTherapyList = (list: AIDiagnose.TherapyType[]) => {
  if (!list?.length) return [];

  if (list?.length === 1) {
    return THERAPY_TYPE_2_STEP[list[0]] as AIFormAction[];
  } else {
    return (
      list
        // 融合方案排序
        ?.sort((a, b) => THERAPY_TYPE_SORT_ORDER.indexOf(a) - THERAPY_TYPE_SORT_ORDER.indexOf(b))
        ?.map((item, index) =>
          index === list?.length - 1 ? THERAPY_TYPE_2_STEP[item] : [...THERAPY_TYPE_2_STEP[item], 'transition-page']
        )
        ?.flat()
        //  去除非transiton-page的重复步骤
        ?.filter((item, index, arr) => arr.indexOf(item) === index || item === 'transition-page') as AIFormAction[]
    );
  }
};
